import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";
// React DateTime
import Datetime from "react-datetime";
import moment from "moment";
// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import FormAction from "../../../components/Actions/FormAction";
import {
  deleteData,
  getAlert,
  getDataWithJoin,
  insertData,
  updateData,
} from "../../../../utils/SamuiUtils";
import { useNavigate } from "react-router-dom";

const Form = ({
  callInitialize,
  mode,
  name,
  formData,
  setFormData,
  selectedData,
  dataEmpPosition,
  dataEmpDept,
}) => {
  console.debug("FormData", formData);
  const [initialFormData, setInitialFormData] = useState({});
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => {
    setShowPassword(!showPassword);
  };

  useEffect(() => {
    const compId = localStorage.getItem("company");
    if (compId) {
      setFormData((prevData) => ({
        ...prevData,
        comp_id: compId,
      }));
    }
  }, [setFormData]);

  useEffect(() => {
    if (mode === "I") {
      const initialData = {
        emp_id: parseInt(window.localStorage.getItem("emp_id"), 10),
        emp_code: "",
        emp_prefix: "",
        emp_name: "",
        emp_dept: "",
        emp_position: "",
        emp_position_detail: "",
        emp_startdate: moment().format("YYYY-MM-DD"), // วันที่ปัจจุบัน
        emp_tel: "",
        emp_status: "Y",
        emp_uuser: "",
        emp_ppass: "",
        emp_pin: "",
        gold_so: 0,
        comp_id: parseInt(window.localStorage.getItem("company"), 10),
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    } else if (mode === "U") {
      const initialData = {
        emp_id: parseInt(selectedData.Emp_Id, 10),
        emp_code: selectedData.Emp_Code,
        emp_prefix: selectedData.Emp_Prefix,
        emp_name: selectedData.Emp_Name,
        emp_dept: parseInt(selectedData.Emp_Dept, 10),
        emp_position: parseInt(selectedData.Emp_Position, 10),
        emp_position_detail: selectedData.Emp_Position_Detail,
        emp_startdate: selectedData.Emp_StartDate,
        emp_tel: selectedData.Emp_Tel,
        emp_status: selectedData.Emp_Status,
        emp_uuser: selectedData.Emp_UUser,
        emp_ppass: selectedData.Emp_PPass,
        emp_pin: selectedData.Emp_PIN,
        gold_so: parseFloat(selectedData.Gold_SO, 10),
        comp_id: parseInt(window.localStorage.getItem("company"), 10),
      };
      setFormData(initialData);
      setInitialFormData(initialData);
    }
  }, [mode, setFormData, selectedData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChangeDataEmpDept = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleChangeDataEmpPosition = (e) => {
    const { name, value } = e.target;

    const selectedEmpPosition = dataEmpPosition?.find(
      (type) => type.PST_Id === parseInt(value, 10)
    );

    setFormData((prev) => ({
      ...prev,
      emp_position: value,
      emp_position_detail: selectedEmpPosition
        ? selectedEmpPosition.PST_Name
        : "",
    }));
  };

  const handleDateChange = (date) => {
    setFormData({
      ...formData,
      emp_startdate: moment(date).format("DD-MM-YYYY"), // Format date as needed
    });
  };

  const handleInsertEmployee = async () => {
    try {
      const { emp_id, ...dataToInsert } = formData; // กรอง emp_id ออกก่อน

      const sanitizeData = (data) => {
        const sanitized = { ...data };
        sanitized.emp_dept = data.emp_dept === "" ? 1 : parseInt(data.emp_dept);
        sanitized.emp_position =
          data.emp_position === "" ? 1 : parseInt(data.emp_position);
        sanitized.gold_so = data.gold_so === "" ? 0 : parseFloat(data.gold_so);
        sanitized.emp_tel = data.emp_tel === "" ? null : data.emp_tel;
        sanitized.emp_status = data.emp_status === "" ? "Y" : data.emp_status;

        sanitized.emp_startdate =
          data.emp_startdate === "" ? new Date() : data.emp_startdate;

        return sanitized;
      };
      const sanitizedData = sanitizeData(dataToInsert);

      const fields = Object.keys(sanitizedData).join(", ");
      const values = Object.values(sanitizedData);

      const res = await insertData("Tb_Set_Employee", fields, values);

      if (res?.status === "OK") {
        getAlert("OK", "บันทึกสำเร็จ");
        callInitialize();
      } else {
        getAlert("FAILED", res?.message || "ไม่สามารถบันทึกข้อมูลได้");
      }
    } catch (error) {
      console.error("Error inserting employee:", error);
      getAlert(
        "FAILED",
        "ไม่สามารถบันทึกข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };
  const formatValues = (data) => {
    const { emp_id, ...rest } = data;
    return rest;
  };

  const handleUpdateEmployee = async () => {
    try {
      const where = { emp_id: formData.emp_id };
      const values = formatValues(formData);
      const res = await updateData("Tb_Set_Employee", values, where);
      if (res) {
        // ถ้า emp_id ตรงกับ localStorage ให้อัพเดท name 
        if (
          parseInt(window.localStorage.getItem("emp_id"), 10) ===
          formData.emp_id
        ) {
          window.localStorage.setItem("name", formData.emp_name);
        }
        getAlert("OK", "อัปเดตข้อมูลสำเร็จ");
        callInitialize();
      }
    } catch (error) {
      getAlert(
        "FAILED",
        "ไม่สามารถอัปเดตข้อมูลได้ เนื่องจากมีข้อมูลนี้อยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  const checkEmCode = async () => {
    const { item_id, ...dataToInsert } = formData;
    const resItemCode = await getDataWithJoin(
      `a.*`,
      `[dbo].[Tb_Set_Employee] AS a`,
      `WHERE a.Emp_Code = '${formData.emp_code}'`,
      ""
    );

    if (resItemCode && resItemCode.length > 0) {
      getAlert("FAILED", "มีรหัสพนักงานแล้ว");
      setFormData((prev) => ({ ...prev, emp_code: "" }));
    } else {
      getAlert("SUCCESS", "รหัสพนักงานนี้สามารถใช้ได้");
    }
  };

  const handleDelete = async () => {
    try {
      getAlert("C_DIALOG", "ยืนยันการลบข้อมูล", async (isConfirm) => {
        if (isConfirm) {
          await deleteData(
            "Tb_Set_Employee",
            `WHERE Emp_Id = ${selectedData.Emp_Id}`
          );
          getAlert("OK", "ลบข้อมูลสำเร็จ");
          await callInitialize();
        }
      });
    } catch (error) {
      getAlert("FAILED", "ไม่สามารถลบข้อมูลได้ กรุณาลองใหม่อีกครั้ง");
    }
  };

  const handleSubmit = async (e) => {
    console.debug(
      "handleSubmit",
      !formData.emp_code ||
        !formData.emp_dept ||
        !formData.emp_name ||
        !formData.emp_position
    );
    try {
      if (
        !formData.emp_code ||
        // !formData.emp_dept ||
        !formData.emp_name
        // ||
        // !formData.emp_position
        // ||
        // !formData.emp_position_detail
      ) {
        getAlert("WARNING", "โปรดกรอกข้อมูลให้ครบถ้วน");
        return;
      }
      if (mode === "I") {
        await handleInsertEmployee();
      } else if (mode === "U") {
        await handleUpdateEmployee();
      }
      await callInitialize();
      setFormData({
        emp_id: "", // Int
        emp_code: "",
        emp_prefix: "",
        emp_name: "",
        emp_dept: "",
        emp_position: "",
        emp_position_detail: "",
        emp_startdate: "",
        emp_tel: "",
        emp_status: "Y",
        emp_uuser: "",
        emp_ppass: "",
        emp_pin: "",
        gold_so: "",
        comp_id: parseInt(window.localStorage.getItem("company"), 10), // Ensure comp_id is a number
      });
    } catch (error) {
      console.error("Error in handleSubmit:", error);
      getAlert(
        "WARNING",
        "โปรดตรวจสอบข้อมูลอีกครั้ง ข้อมูลนี้มีอยู่ในระบบแล้ว"
      );
      return null;
    }
  };

  return (
    <form>
      <Breadcrumbs
        isShowStatus={mode === "U"}
        items={[
          { name: "ข้อมูลตั้งต้น", url: "/initialdata" },
          { name: name, url: "/employee" },
          { name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name, url: "#" },
        ]}
      />
      <div className="container p-4">
        <div className="card shadow-sm ">
          <div className="card-body">
            <div className="row g-3 mt-1 px-3">
              <div className="col-md-4">
                <label>รหัสพนักงาน</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="emp_code"
                  value={formData.emp_code || ""}
                  onBlur={checkEmCode}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <label className="">คำนำหน้า</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="emp_prefix"
                  value={formData.emp_prefix || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4">
                <label className="">ชื่อ</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="emp_name"
                  value={formData.emp_name || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-4 mt-2">
                <label className="">แผนก</label>
                {/* <input
              type="number"
              className="form-control input-spacing"
              name="emp_dept"
              value={formData.emp_dept || ""}
              onChange={handleChange}
            /> */}
                <div class="input-group">
                  <select
                    className="form-select input-spacing"
                    name="emp_dept"
                    value={formData.emp_dept}
                    onChange={handleChangeDataEmpDept}
                    style={{ color: "black" }}
                    disabled={dataEmpDept.length <= 0}
                  >
                    {dataEmpDept.map((type, index) => (
                      <option key={index} value={type.Dept_Id}>
                        {type.Dept_Name}
                      </option>
                    ))}
                  </select>
                  {dataEmpDept.length <= 0 ? (
                    <div class="input-group-append">
                      <button
                        onClick={() => navigate("/dept")}
                        class="btn btn-lg text-white"
                        style={{
                          padding: "12px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#EF6C00",
                        }}
                        type="button"
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="col-md-4 mt-2">
                <label className="">ตำแหน่ง</label>
                {/* <input
              type="number"
              className="form-control input-spacing"
              name="emp_position"
              value={formData.emp_position || ""}
              onChange={handleChange}
            /> */}
                <div class="input-group">
                  <select
                    className="form-select input-spacing"
                    name="emp_position"
                    value={formData.emp_position || ""}
                    onChange={handleChangeDataEmpPosition}
                    style={{ color: "black" }}
                    disabled={dataEmpPosition.length <= 0}
                  >
                    {dataEmpPosition.map((type, index) => (
                      <option key={index} value={type.PST_Id}>
                        {type.PST_Name}
                      </option>
                    ))}
                  </select>
                  {dataEmpPosition.length <= 0 ? (
                    <div class="input-group-append">
                      <button
                        onClick={() => navigate("/position")}
                        class="btn btn-lg text-white"
                        style={{
                          padding: "12px",
                          borderRadius: "0 5px 5px 0",
                          backgroundColor: "#EF6C00",
                        }}
                        type="button"
                      >
                        +
                      </button>
                    </div>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="col-md-4 mt-2">
                <label className="">รายละเอียดตำแหน่ง</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="emp_position_detail"
                  value={formData.emp_position_detail || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6 mt-2">
                <label className="">เบอร์โทร</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="emp_tel"
                  value={formData.emp_tel || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6 mt-2">
                <label>วันที่เริ่มงาน</label>
                <Datetime
                  value={
                    formData.emp_startdate
                      ? moment(formData.emp_startdate).format("DD-MM-YYYY")
                      : ""
                  }
                  dateFormat="DD-MM-YYYY"
                  timeFormat={false}
                  onChange={handleDateChange}
                  inputProps={{ readOnly: true }}
                />
              </div>
              <div className="col-md-6 mt-2">
                <label className="">บัญชีผู้ใช้</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="emp_uuser"
                  value={formData.emp_uuser || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6 mt-2">
                <label className="">รหัสผ่าน</label>
                <div className="input-group">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="form-control input-spacing"
                    name="emp_ppass"
                    value={formData.emp_ppass || ""}
                    onChange={handleChange}
                  />
                  <button
                    type="button"
                    className="btn btn-lg text-white"
                    onClick={toggleShowPassword}
                    style={{
                      padding: "9px",
                      borderRadius: "0 5px 5px 0",
                      backgroundColor: "#EF6C00",
                    }}
                  >
                    <i
                      className={
                        showPassword ? "fas fa-eye-slash" : "fas fa-eye"
                      }
                    />
                  </button>
                </div>
              </div>
              <div className="col-md-6 mt-2">
                <label className="">Pin พนักงาน</label>
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="emp_pin"
                  value={formData.emp_pin || ""}
                  onChange={handleChange}
                />
              </div>
              <div className="col-md-6 mt-2">
                <label className="">สถานะ</label>
                <select
                  className="form-select"
                  name="emp_status"
                  value={formData.emp_status || "Y"} // Set default value to "Y"
                  onChange={handleChange}
                  style={{ color: "black" }}
                >
                  <option value="Y">ใช้งาน</option>
                  <option value="N">ไม่ใช้งาน</option>
                </select>
              </div>
              {/* <div className="col-3 my-1">
          <div className="d-flex align-items-center">
            <label className="">Gold_So</label>
            <input
              type="number"
              className="form-control input-spacing"
              name="gold_so"
              value={formData.gold_so || ""}
              onChange={handleChange}
            />
          </div>
        </div> */}
              <div className="col-3 my-1" />
              <div className="col-3 my-1" />
              <div className="col-3 my-1" />
            </div>
            <div className="row mt-4">
              {mode !== "I" ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  {/* ปุ่มลบ */}
                  <button
                    onClick={() => handleDelete()}
                    type="button"
                    className="btn btn-lg shadow text-white"
                    style={{
                      width: "8%",
                      backgroundColor: "#dc3545",
                      fontSize: "16px",
                    }}
                  >
                    ลบ
                  </button>

                  {/* กลุ่มปุ่มยกเลิก และบันทึก */}
                  <div style={{ display: "flex", gap: "20px" }}>
                    <button
                      onClick={() => (window.location.href = "/employee")}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#000000",
                        fontSize: "16px",
                      }}
                    >
                      ยกเลิก
                    </button>
                    <button
                      onClick={() => handleUpdateEmployee()}
                      type="button"
                      className="btn btn-lg shadow text-white"
                      style={{
                        backgroundColor: "#EF6C00",
                        fontSize: "16px",
                      }}
                    >
                      บันทึก
                    </button>
                  </div>
                </div>
              ) : (
                <div style={{ display: "flex" }}>
                  <FormAction
                    onSubmit={handleSubmit}
                    onUpdate={handleSubmit}
                    onDelete={handleDelete}
                    mode={mode}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default Form;
